const API = process.env.REACT_APP_API_URL;
const REST_API = process.env.REACT_APP_REST_API_URL;
const SOCKET_API = process.env.REACT_APP_SOCKET_API_URL;
const { OS_TOKEN } = process.env;

export { API, REST_API, SOCKET_API, OS_TOKEN };
